// Source: trinity/trinity/Resources/TriGeometryRes.h
// Generated by format-carbon carbon-class --emit. Verify against resources/Tr2RaycastGeometryRes.json.
import { type } from "@carbonenginejs/runtime-utils/schema";
import { CjsModel } from "@carbonenginejs/runtime-utils/model";

/** Tr2RaycastGeometryRes (resources) - generated from schema shapeHash f30f73e8.... */
@type.define({ className: "Tr2RaycastGeometryRes", family: "resources" })
export class Tr2RaycastGeometryRes extends CjsModel
{

  /** m_lodIndices (std::vector<int32_t>) */
  @type.list("int32_t")
  lodIndices = [];

  /** m_bvh (BVH::BoundingVolumeHierarchy) */
  @type.rawStruct("BVH::BoundingVolumeHierarchy")
  bvh = null;

}
